import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Subscription} from "rxjs";
import {DjangoApiService} from "../../../shared/services/django-api.service";
import {SnackbarService} from "../../../shared/services/snackbar.service";
import {LanguageService} from "../../../shared/services/language.service";
import {LangChangeEvent, TranslateModule, TranslateService} from "@ngx-translate/core";
import {AuthService} from "../../../shared/services/auth.service";
import {ActivatedRoute, RouterLink} from "@angular/router";
import {MatDialog} from "@angular/material/dialog";
import {DialogConfirmComponent} from "../../../shared/components/dialogs/dialog-confirm/dialog-confirm.component";
import {CardsBasicComponent} from "../../../shared/components/cards/cards-basic/cards-basic.component";
import {LocalizeRouterPipe} from "@gilsdav/ngx-translate-router";
import {MatButton, MatIconButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {MatListItem, MatNavList} from "@angular/material/list";
import {ParseJsonPipe} from "../../../shared/pipes/parse-json.pipe";

@Component({
  selector: 'app-data-source-list',
  standalone: true,
  imports: [
    CardsBasicComponent,
    LocalizeRouterPipe,
    MatButton,
    MatIcon,
    MatIconButton,
    MatListItem,
    MatNavList,
    TranslateModule,
    RouterLink,
    ParseJsonPipe
  ],
  templateUrl: './data-source-list.component.html',
  styleUrl: './data-source-list.component.css'
})
export class DataSourceListComponent implements OnInit, OnDestroy{
  productId!: any;
  dataList: any[] = [];
  currentLanguage!: string;
  langChangeSubscription: Subscription | null = null;

  private subscriptions: Subscription = new Subscription();
  @ViewChild('fileInput') fileInput!: ElementRef;

  constructor(
    private _apiService: DjangoApiService,
    private _snackbarService: SnackbarService,
    private _languageService: LanguageService,
    private _translate: TranslateService,
    public _authService: AuthService,
    public _route: ActivatedRoute,
    private _dialog: MatDialog) {
  }

  ngOnInit() {
    this.setupLanguageSubscription();
    this.getRouteParams();
  }

  private setupLanguageSubscription(): void {
    this.currentLanguage = this._languageService.getLanguage();
    this.subscriptions.add(
      this.langChangeSubscription = this._translate.onLangChange.subscribe((event: LangChangeEvent) => {
        this.currentLanguage = event.lang;
      })
    );
  }

  private getRouteParams(): void {
    this._route.params.subscribe(params => {
      this.productId = this._route.snapshot.parent?.params['productId'];
    });
    this.loadDataSourceList();
  }

  private loadDataSourceList(): void {
    this.subscriptions.add(
      this._apiService.fetchDataSourceList(undefined, this.productId).subscribe({
        next: (response: any) => {
          this.dataList = response;
        },
        error: (error: any) => {
          console.error('There was an error fetching the user information', error);
        }
      })
    );
  }

  confirmDelete(dataId: number, event: Event) {
    event.stopPropagation();
    event.preventDefault();

    DialogConfirmComponent.openDeleteDialog(this._dialog, this._translate).subscribe(result => {
      if (result) {
        this.deleteCustomData(dataId);
      }
    });
  }

  deleteCustomData(dataId: number) {
    this.subscriptions.add(
      this._apiService.deleteDataSource(dataId).subscribe({
        next: (response: any) => {
          this._snackbarService.show(response.message);
          this.loadDataSourceList();
        },
        error: (error) => {
          console.log(error);
        }
      })
    );
  }


  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }


}
